// i18n 按需加载器
var i18n = {};

/**
 * 动态加载语言包，加载完成后执行回调
 * @param {string} lang - 语言代码，如 'en'、'ru'
 * @param {function} callback - 加载完成后的回调
 */
function i18n_load(lang, callback) {
    if (i18n[lang]) {
        // 已缓存，直接回调
        if (typeof callback === 'function') callback();
        return;
    }
    // 显示加载动画
    $('.main>.main_loading').addClass('active');
    var script = document.createElement('script');
    script.src = '/js/i18n/' + lang + '.js';
    script.onload = function() {
        // 隐藏加载动画
        $('.main>.main_loading').removeClass('active');
        if (typeof callback === 'function') callback();
    };
    script.onerror = function() {
        // 语言包不存在时回退到英文
        if (lang !== 'en') {
            i18n_load('en', callback);
        } else {
            // 回退也失败时隐藏加载动画
            $('.main>.main_loading').removeClass('active');
            if (typeof callback === 'function') callback();
        }
    };
    document.head.appendChild(script);
}
